import {
  largeWidthBreakPoint,
  maxWidth500,
  maxWidth600,
} from "themes/default/breakpoints"
import { theme } from "themes/default/theme"

export const styles = {
  container: {
    ...theme.mixins.modalContent,
    overflow: "visible",
    pt: 0,
    px: 1,
    pb: 1,
    maxWidth: 1200,
    [maxWidth600]: {
      maxHeight: `calc(100% - 120px)`,
    },
  },
  closeButton: (theme) => ({
    position: "absolute",
    zIndex: 1,
    width: 45,
    height: 45,
    borderRadius: "50%",
    backgroundColor: theme.palette.background.default,
    color: theme.palette.primary.main,
    right: -20,
    top: -20,
    border: `3px solid ${theme.palette.primary.main}`,
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: theme.palette.background.default,
      transform: "scale(1.2)",
    },
    [maxWidth500]: {
      right: -10,
    },
  }),
  mainImage: {
    width: "75px!important",
    height: "75px!important",
    position: "absolute!important",
    zIndex: 1,
    top: -35,
    left: "50%",
    transform: "translateX(-50%)",
    [maxWidth600]: {
      width: "50px!important",
      height: "50px!important",
    },
    [largeWidthBreakPoint]: {
      width: "50px!important",
      height: "50px!important",
    },
  },
  content: (theme) => ({
    backgroundColor: theme.palette.background.main,
    borderRadius: 5,
    position: "relative",
    padding: 1.25,
    pb: 2.5,
    pt: "30px!important",
    maxHeight: 800,
  }),
  libraryButton: (theme) => ({
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.common.black,
    textTransform: "none",
    borderRadius: 12.5,
    minWidth: 100,
    "&:hover": {
      backgroundColor: theme.palette.secondary.main,
    },
    [maxWidth600]: {
      minWidth: 0,
    },
  }),
  allModulesComboBox: (theme) => ({
    minWidth: 150,
    backgroundColor: theme.palette.secondary.main,
    color: "#000",
    borderRadius: 12.5,
    outline: "none",
  }),
  searchInput: (theme) => ({
    backgroundColor: theme.palette.background.default,
    border: `1px solid ${theme.palette.secondary.main}`,
    color: theme.palette.common.black,
    borderRadius: 12.5,
    textAlign: "center",
    height: 32,
    maxWidth: 180,
    "& input": {
      color: theme.palette.common.black,
      "-webkit-text-fill-color": theme.palette.common.black,
    },
    "&.Mui-disabled input": {
      color: theme.palette.common.black,
      "-webkit-text-fill-color": theme.palette.common.black,
    },
  }),
  searchBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    pt: "5px",
  },
  inputButton: (theme) => ({
    position: "absolute",
    right: 0,
    height: 38,
    width: 38,
    top: 2,
    borderRadius: "50%",
    border: "none",
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.common.black,
    fontSize: 14,
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: theme.palette.secondary.main,
    },
  }),
  menuItem: (theme) => ({
    padding: "5px 20px",
    cursor: "pointer",
    borderBottom: `1px solid rgba(0, 0, 0, 0.1)`,
    textAlign: "center",
    justifyContent: "center",
    "&:hover": {
      backgroundColor: "rgba(192, 0, 0, 0.2)",
    },
  }),
}
